export function addTemporaryMessage(queryClient, threadId, message) {
  const data = queryClient.getQueryData(["thread-chats", threadId])

  if (!data) {
    console.log("No previous data found")
    return
  }

  const oldMessages = data?.pages?.[0]?.data?.messages ?? []
  const messages = [message, ...oldMessages]

  console.log("#SDT Old messages:", oldMessages)
  console.log("#SDT New messages:", messages)

  const updatedData = {
    ...data,
    pages: [
      {
        ...data.pages[0],
        data: {
          ...data.pages[0].data,
          messages,
        },
      },
    ],
  }

  queryClient.setQueryData(["thread-chats", threadId], updatedData)
  console.log("#SDT Updated data:", updatedData)
}

export function deleteLastMessage(queryClient, threadId) {
  const previousData = queryClient.getQueryData(["thread-chats", threadId])

  if (!previousData) {
    console.log("No previous data found")
    return
  }
  console.log("#SDT Previous Data", previousData)

  const oldMessages = previousData?.pages?.[0]?.data?.messages ?? []

  if (oldMessages.length === 0) {
    console.log("No messages to delete")
    return
  }

  const messages = [...oldMessages.slice(1, -1)]

  const newData = {
    ...previousData,
    pages: [
      {
        ...previousData.pages[0],
        data: {
          ...previousData.pages[0].data,
          messages,
        },
      },
    ],
  }

  queryClient.setQueryData(["thread-chats", threadId], newData)
  console.log("Updated data after deletion:", newData)
}

export function replaceLastMessage(queryClient, threadId, newMessage) {
  const previousData = queryClient.getQueryData(["thread-chats", threadId])

  if (!previousData) {
    console.log("No previous data found")
    return
  }
  console.log("#SDT Previous Data", previousData)

  const oldMessages = previousData?.pages?.[0]?.data?.messages ?? []

  if (oldMessages.length === 0) {
    console.log("No messages to replace")
    return
  }

  const messages = [newMessage, ...oldMessages.slice(1, -1)]

  const newData = {
    ...previousData,
    pages: [
      {
        ...previousData.pages[0],
        data: {
          ...previousData.pages[0].data,
          messages,
        },
      },
    ],
  }

  queryClient.setQueryData(["thread-chats", threadId], newData)
  console.log("Updated data after replacement:", newData)
}

export function updateLastMessageStatus(queryClient, threadId, metaData) {
  const previousData = queryClient.getQueryData(["thread-chats", threadId])

  if (!previousData) {
    console.log("No previous data found")
    return
  }

  const oldMessages = previousData?.pages?.[0]?.data?.messages ?? []

  if (oldMessages.length === 0) {
    console.log("No messages to update")
    return
  }

  // ...existing code...

  let existingMeta = {}
  try {
    // Handle both string and object meta formats
    existingMeta =
      typeof oldMessages[0].meta === "string"
        ? JSON.parse(oldMessages[0].meta)
        : oldMessages[0].meta || {}
  } catch (error) {
    console.error("Error parsing meta:", error)
    existingMeta = {
      status: "",
      timestamp: "",
      failureResponse: {},
    }
  }
  const updatedMeta = {
    ...existingMeta,
    status: metaData.status,
    timestamp: metaData.timestamp,
    failureResponse: metaData.failureResponse,
  }
  // Convert the plain object to properly escaped string format
  const formattedMeta = JSON.stringify(updatedMeta)
    .replace(/([{,])"(\w+)":/g, '$1"$2": ') // Add space after colon
    .replace(/},}/g, "}, }") // Add space before closing braces

  const updatedMessage = {
    ...oldMessages[0],
    sending: false,
    meta: formattedMeta,
    modified_at: new Date().toISOString(),
  }

  const messages = [updatedMessage, ...oldMessages.slice(1)]

  const newData = {
    ...previousData,
    pages: [
      {
        ...previousData.pages[0],
        data: {
          ...previousData.pages[0].data,
          messages,
        },
      },
    ],
  }

  queryClient.setQueryData(["thread-chats", threadId], newData)
  console.log("#SDT Updated message status:", newData)
}

/// For threads part **********
export function updateTemporaryThread(
  queryClient,
  threadId,
  search,
  isUnread,
  isRequested,
  optimisticThread
) {
  const data = queryClient.getQueryData([
    "chats",
    search,
    isUnread,
    isRequested,
  ])

  const threads = data?.pages?.[0]?.data?.threads || []
  if (!threads.length) return

  // lets find the thread in the threads list
  const threadIndex = threads.findIndex((th) => th.thread_id === threadId)
  if (threadIndex === -1) return

  // now save the updated thread back to the cache
  const updatedMessage = {
    ...threads[threadIndex],
    last_message: {
      content: optimisticThread.message,
    },
    unread_count: optimisticThread.thread_unread_count,
    is_requested: optimisticThread.thread_is_requested,
    is_read: optimisticThread.thread_unread_count <= 0,
  }
  console.log("#SDT Thread before update:", updatedMessage)
  threads[threadIndex] = updatedMessage

  //swap the thread with the first one
  const tempThread = threads[threadIndex]
  threads.splice(threadIndex, 1)
  threads.unshift(tempThread)
  // update the thread in pages[0].data.threads
  const updatedData = {
    ...data,
    pages: [
      {
        ...data.pages[0],
        data: {
          ...data.pages[0].data,
          threads,
        },
      },
    ],
  }
  console.log("#SDT Updated data:", updatedData)
  queryClient.setQueryData(["chats", "", false, false], updatedData)

  console.log("#SDT Updated data:", updatedData)
}

export function addTemporaryThread(
  queryClient,
  search,
  isUnread,
  isRequested,
  optimisticThread
) {
  const data = queryClient.getQueryData([
    "chats",
    search,
    isUnread,
    isRequested,
  ])

  if (!data) {
    console.log("No previous data found")
    return
  }

  const oldthreads = data?.pages?.[0]?.data?.threads || []
  const newThreads = [optimisticThread, ...oldthreads]

  const updatedData = {
    ...data,
    pages: [
      {
        ...data.pages[0],
        data: {
          ...data.pages[0].data,
          newThreads,
        },
      },
    ],
  }

  console.log("#SDT Updated data:", updatedData)
  queryClient.setQueryData(["chats", "", false, false], updatedData)

  console.log("#SDT Updated data:", updatedData)
}
